exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-U_S{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}.w-U_S:hover{opacity:.7}._254z9{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._1E4vt{position:absolute;z-index:100;visibility:hidden;transition:opacity .2s,visibility .2s;opacity:0}._1E4vt.SSq3v{padding:4px 5px;background:rgba(0,0,0,.5)}._1E4vt.wTU1r{visibility:visible;opacity:1}.SSq3v .p6UOT{font-size:11px;line-height:12px;white-space:nowrap;color:#fff}", ""]);

// exports
exports.locals = {
	"controlButton": "w-U_S",
	"hidden": "_254z9",
	"tooltip": "_1E4vt",
	"showAsText": "SSq3v",
	"tooltipVisible": "wTU1r",
	"tooltipInner": "p6UOT"
};